import React from 'react';
import type { QuestStepState } from '../../../../../shared/quests/questChain';

/*
 * The quest path's step icons, drawn as inline SVG rather than Unicode glyphs
 * (the vendored fonts carry narrow ranges). The vine corner, wax seal and star
 * live in the tome kit (src/game/ui/primitives/tome/TomeOrnaments.tsx).
 */

/** Step node on the quest path: a leaf for done, a bud for active, a glowing ring for next, a lock for locked. */
export const CodexStepIcon: React.FC<{ state: QuestStepState }> = ({ state }) => <svg className="npc-codex-step-icon"
  viewBox="0 0 20 20" aria-hidden="true" data-step-icon={state}>
  {state === 'done' && <>
    <path d="M4 15 C3 8 9 3 17 3 C17 11 12 16 4 15 Z" fill="#3d6b41" stroke="#204629" strokeWidth="1" />
    <path d="M5 14 L13 6" stroke="#bfe3a8" strokeWidth="1.2" strokeLinecap="round" />
  </>}
  {state === 'active' && <>
    <circle cx="10" cy="10" r="7" fill="#f4e3b4" stroke="#8a5a12" strokeWidth="1.4" />
    <path d="M10 3 A7 7 0 0 1 10 17 Z" fill="#c9a35c" />
  </>}
  {state === 'next' && <>
    <circle cx="10" cy="10" r="8" fill="none" stroke="#c9a35c" strokeWidth="1.2" opacity="0.6" />
    <circle cx="10" cy="10" r="4.5" fill="#f0d18a" stroke="#8a5a12" strokeWidth="1.2" />
  </>}
  {state === 'locked' && <>
    <rect x="5" y="9" width="10" height="8" rx="1.5" fill="#cbbd9a" stroke="#7a6a4a" strokeWidth="1.1" />
    <path d="M7 9 V7 a3 3 0 0 1 6 0 V9" fill="none" stroke="#7a6a4a" strokeWidth="1.3" />
  </>}
</svg>;
